import { request } from '@/common/utils/request'

export function accompanyAddInit (params) {
  return request.get({
    url: 'feidian.bdapp.accompany.init',
    params
  }).then(res => res.data)
}
export function accompanyAddRecord (params) {
  return request.post({
    url: ' feidian.bdapp.accompany.addRecord',
    params
  }).then(res => res.data)
}

export function getAccoVisitList (params) {
  return request.get({
    url: 'feidian.bdapp.accompany.getVisitList',
    params
  }).then(res => res.data)
}
